<template>
  <div
    class="site"
    :class="{ debug: debug }"
    :style="{
      top: marginVertical + 'px ',
      bottom: marginVertical + 'px ',
      left: +marginHorizontal + 'px',
      right: +marginHorizontal + 'px'
    }"
    data-test-id="signage-site"
    @click="$router.push('/')"
  >
    <warning-message
      v-if="!site.loaded"
      is-loading-message
    >
      {{ $t('status.loading') }}
    </warning-message>
    <div v-else-if="site">
      <warning-message
        v-if="movies.length == 0"
      >
        {{ $t('showing.noShowingsToday') }}
      </warning-message>
      <!-- We have a showtimes-->
      <div class="fixed-full column">
        <div class="col-auto q-py-sm">
          <img
            class="site-logo"
            :src="site.lightLogoImageUrl"
          >
          <div class="time text-uppercase">
            {{ site.siteTime.format("h:mm a") }}
          </div>
        </div>
        <div class="col column">
          <div
            v-for="(showings, movieId) in movies"
            :key="movieId"
            class="col row movie-container"
          >
            <div
              class="col-3 row items-center"
              style="max-height: 100%"
            >
              <img
                style="max-height: 100%; object-fit: contain;"
                :src="showings[0].movie.posterImageUrl"
                class="col q-pa-md"
              >
            </div>
            <div class="col-9 row justify-evenly items-center">
              <div
                v-for="showing in showings"
                :key="showing.id"
                class="col-auto showing"
                :style="styleForShowing(showing)"
              >
                {{ showing.siteTime.format("h:mm a") }}
              </div>
              <div
                v-for="i in $_.range(maxShowings - showings.length)"
                :key="i"
                class="text-uppercase"
                style="color: #00000000"
              >
                none
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <warning-message
      v-else-if="errorOccurred"
    >
      A network error occurred
    </warning-message>
    <warning-message
      v-else
    >
      {{ `Unknown Site - ${$route.params.id}` }}
    </warning-message>
  </div>
</template>

<script>
import WarningMessage from 'src/modules/signage/components/WarningMessage'
import ShowingsSignageConfigurationMixin from 'src/modules/signage/mixins/ShowingsSignageConfigurationMixin'

export default {
  name: 'SitePortrait',
  components: {
    WarningMessage
  },
  mixins: [ShowingsSignageConfigurationMixin],
  models: {
    site: {
      fields: ['id', 'name', 'primaryColor', 'lightLogoImage', 'migratedTo'],
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default'
      },
      variables () {
        return {
          id: this.siteId
        }
      },
      immediate: true
    }
  },
  props: {
    overrideSiteId: {
      type: Number,
      required: false,
      default: null
    },
    overrideCover: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      errorOccurred: false
    }
  },
  computed: {
    movies () {
      if (!this.site) return

      return _(this.site.todaysShowings.data)
        .groupBy('movie.id')
        .sortBy(showings => -showings.length) // Second priority is number of showings
        .sortBy(showings => showings[0].screen.displayOrder) // First priority is what screen it is in
        .value()
    },
    maxShowings () {
      if (!this.site || !this.site.todaysShowings) return 0

      return _(this.movies).values().map('length').max()
    },
    cover () {
      return this.overrideCover || this.$route.query.cover || false
    },
    siteId () {
      return this.overrideSiteId || this.$route.params?.siteId
    }
  },
  configuration: ['currentSite'],

  async mounted () {
    this.moviesIntervalId = setInterval(() => {
      this.site.fetch(true)
    }, 10 * 60 * 1000)

    await this.site.fetch()

    if (this.$signage) {
      // Fetching the site when in the app mode of digital-signage, sets the site_id cookie
      // This will reload the configuration data after being authenticated
      this.$handleAuthChange()
    }
  },
  beforeUnmount () {
    if (this.timeIntervalId) clearInterval(this.timeIntervalId)

    if (this.moviesIntervalId) clearInterval(this.moviesIntervalId)
  },
  methods: {
    styleForShowing (showing) {
      if (showing.current) {
        return 'font-weight: extra-bold; ' + 'color: ' + this.$lightenColor(this.site.primaryColor, 80)
      } else if (showing.past) {
        return 'font-weight: normal; text-decoration: line-through; ' + 'color: ' + this.$lightenColor(this.site.primaryColor, 20)
      } else {
        return 'font-weight: bold; ' + 'color: ' + this.$lightenColor(this.site.primaryColor, 40)
      }
    }
  }
}
</script>

<style scoped>
.site {
  background-color: #161616;
  color: #fff;
  position: absolute;
}

.site.debug {
  border: solid 1px red;
}

.site-logo {
  max-width: 20vh;
  max-height: 5vh;
}

.time {
  position: absolute;
  top: 2vh;
  right: 2vh;
  font-size: 3vh;
}

.movie-grid {
  flex-grow: 1;

  display: flex;
}
.movie-container:nth-child(even) {
  background-color: #101010;
}
.movie-container:nth-child(odd) {
  background-color: #191919;
}
.debug .movie-container > div {
  border: solid 1px red;
}

.poster {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 100%;
}
.poster.cover {
  background-size: cover;
}
.movie-name {
  font-size: 2vh;

  text-overflow: ellipsis;

  overflow: hidden;
  text-overflow: ellipsis;

  max-height: 3em;
  height: 3em;
}

.showing {
  font-size: 3.5vh;
  font-weight: 800;
  line-height: 3vh;
}
.debug .showing {
  border: solid 1px yellow;
}
.past {
  color: #333;
}
.current {
  color: #1e57ff;
}

</style>
